import { CONFIG } from '../../config';

// HACK_DEV is only used when in DT office
// ROCK_DEV is for general development

/* eslint no-unused-vars: 'off' */
const LOCAL_DEV = 'http://127.0.0.1:8000';
// const REMOTE_DEV = 'http://127.0.0.1:8000';
const REMOTE_DEV = 'https://api-dev.hackhub.com';

const isCNServer = process.env.REACT_APP_SERVER_TARGET === 'cn';

// Production Host
const PROD_HOST = `https://et.hackhub.${isCNServer ? 'cn' : 'com'}`;

let HOST = CONFIG.DEV ? REMOTE_DEV : PROD_HOST;

const hostname = window && window.location && window.location.hostname;
if (hostname === 'dev-seein.hackhub.com') {
  HOST = REMOTE_DEV;
}

export const HHT = CONFIG.DEV
  ? 'https://talent-gamma.hackhub.com'
  : 'https://talent.hackhub.com';

// Connect with Micro Server Screening
// const MS_SCREENING = 'http://localhost:3001';
const MS_SCREENING = CONFIG.DEV
  ? 'https://hhscreening-dev.hackhub.com'
  : `https://hhsc.hackhub.${isCNServer ? 'cn' : 'com'}`;

export const FETCH_APPLICATION_COLLECTION = `${MS_SCREENING}/application/collect`;
export const FETCH_APPLICATION_FIELDS = `${MS_SCREENING}/application/fields`;
export const FETCH_APPLICATION_ADD_PROFILE = `${MS_SCREENING}/application/add`;
export const FETCH_APPLICATION_CREATE = `${MS_SCREENING}/application/createAndUpdate/`;
export const FETCH_APPLICATION_ADD_QUESTION = `${MS_SCREENING}/application/addQuestion/`;
export const HANDLE_APPLICATION_START_OR_CLOSE = `${MS_SCREENING}/application/startOrClose/`;
export const FETCH_USER_APPLICATION_STATUS = `${MS_SCREENING}/application/getUserApplicationStatus/`;


// Chat server
const CHAT_HOST = 'https://hackhub.live';

/* global exports */
const USER = `${HOST}/user`;
export const SEND_VERIFICATION_EMAIL = `${HOST}/tpanel/user/verificationEmailSend/`;
export const FETCH_PUBLIC_POSTINGS = `${HOST}/tpanel/posting/jobSeekers/publicPostingList/`;
export const FORGOT_PWD_RESET_SEND_CODE_EMAIL = `${USER}/send_email_confirm/reset_pwd_via_forgot_pwd/`;
export const VALIDATE_EMAIL_CODE = `${USER}/validateEmailCode/`;
export const RESET_PWD_VIA_FORGOT_PWD = `${USER}/reset_pwd_via_forgot_pwd/`;
export const DUPLICATE_EMAIL_CHECK = `${USER}/checkDuplicateEmail/`;
export const ACCOUNT_REGISTER = `${USER}/accountRegister/`;
export const USER_SIGNUP = `${USER}/register/`;
export const USER_SIGNUP_EMAIL = `${USER}/register/email`; // send welcome email
export const USER_LOGIN = `${USER}/login/`;
export const HACKHUB_ACCOUNT_LOGIN = `${USER}/accountLogin/`;
export const USER_FETCH_THIRD_PARTY = `${USER}/fetch_from_third_party/`;
export const USER_CHECK_THIRD_PARTY = `${USER}/check_third_party/`;
export const USER_CANCEL_SOCIAL_LOGIN = `${USER}/cancelSocialLoginViaBackend/`;
export const USER_PROFILE = `${USER}/hackhub/profile/`;
export const USER_EXPORT_DATA = `${USER}/HHEExportUserData/`;
export const USER_EVENT_SUBMISSION = `${USER}/event_submission/`;
export const PUBLIC_USER_PROFILE = userName => `${HOST}/u/${userName}/`;
export const USER_PROFILE_UPDATE = `${USER}/hackhub/profile/update/`;
export const USER_ACCOUNT_DELETE = `${USER}/hackhub/profile/delete/`;

export const USER_SNS = `${USER}/hackhub/social_media/`;
export const USER_SNS_UPDATE = `${USER}/hackhub/social_media/update/`;

export const USER_PASSWORD_RESET = `${USER}/reset_password/`;
export const USER_UPDATE_PASSWORD = `${USER}/update_password/`;
export const USER_NEW_PASSWORD = `${USER}/submit_reset_password/`;
export const USER_UPDATE_NEW_USER_FIELD = `${USER}/update/new_user/`;

export const USER_POSITION = `${USER}/hackhub/position/`;
export const USER_POSITION_DETAIL = `${USER}/hackhub/position/detail/`;
export const USER_POSITION_DELTE = `${USER}/hackhub/position/delete/`;
//-------------
export const USER_PERMISSION_UPDATE = `${USER}/update_permission/`;
//-------------
export const USER_COMPANY = `${USER}/company/`;
export const USER_COMPANY_DETAIL = `${USER}/company/detail/`;
export const USER_EMAIL_VERIFY = `${USER}/resend_email_confirm/`;
export const USER_EMAIL_CONFIRM = token => `${USER}/email_confirm/${token}/`;

export const STRIPE_CHARGE = `${HOST}/stripe/charge/`;

export const COMPANY_LIST = `${USER}/company/list/`;
export const COMPANY_DELETE = `${USER}/company/delete/`;

export const SEND_PHONE_CODE = `${USER}/send_phone_code/`;
export const VERIFY_PHONE_CODE = `${USER}/verify_phone_code/`;

// Tickets
export const USER_TICKETS_LIST = `${USER}/hackhub/profile/list/charges/`;

// const PROJECT = `${HOST}/project`;
// export const PROJECT_LIST = `${PROJECT}/list/`;
// export const PROJECT_NEW = `${PROJECT}/new/`;
// export const PROJECT_BRIEF = `${PROJECT}/brief/`;
// export const PROJECT_PUBLISH = `${PROJECT}/publish/`;
// export const PROJECT_ANNOUNCEMENT_POST = `${PROJECT}/announcements/`;
// export const PROJECT_ANNOUNCEMENT_LIST = `${PROJECT}/announcements/list/`;
// export const PROJECT_COMMENT_POST = `${PROJECT}/comment/`;
// export const PROJECT_COMMENT_LIST = `${PROJECT}/comment/list/`;
// export const PROJECT_OWN = `${PROJECT}/own/`;
// export const PROJECT_OWN_DELETE = `${PROJECT}/own/delete/`;
// export const PROJECT_OWN_DETAIL = `${PROJECT}/own/detail/`;
// export const PROJECT_INVITE = `${PROJECT}/invite/`;
// export const PROJECT_SUBMISSION = `${PROJECT}/submission/`;
// export const PROJECT_SUBMISSION_LIST = `${PROJECT}/submission/list/`;
// export const PROJECT_SUBMISSION_COMMENT = `${PROJECT}/submission/comment/`;
// export const PROJECT_WINNER = `${PROJECT}/submission/winner/`;
// export const PROJECT_VIEW_INVITE = token => `${PROJECT}/invite/${token}/`;
// export const PROJECT_DELETE = projectId => `${PROJECT}/delete/${projectId}/`;
// export const JOIN_TEAM = teamId => `${PROJECT}/apply/${teamId}/`;
// export const LEAVE_PROJECT = projectId => `${PROJECT}/leave/${projectId}/`;
// export const TEAM_DETAIL = teamId => `${PROJECT}/${teamId}/detail/`;
// export const PROJECT_UPDATE = projectId => `${PROJECT}/${projectId}/update/`;
// export const PROJECT_REFERENCE_LETTER = `${PROJECT}/reference_letter/`;

// CHAT
export const INIT_CHAT = participants => `${CHAT_HOST}/chat/${participants}`;
export const ALL_CHAT = userid => `${CHAT_HOST}/allchat/${userid}`;
export const SINGLE_CHAT = chatId => `${CHAT_HOST}/chat/${chatId}`;
export const POST_CHAT = chatId => `${CHAT_HOST}/chat/new/${chatId}`;

// mentor apis
export const MENTOR_LIST = `${HOST}/user/mentor/list/`;
export const MENTOR_EMAIL = `${HOST}/mentor/bulk_email/`;
export const MENTOR_CONSULTATION = `${HOST}/mentor/consultation/duration/`;
export const MENTOR_END_SESSION = `${HOST}/stripe/charge/mentor/consultation/`;
export const MENTOR_CREATE_CARD = `${HOST}/stripe/card/create/`;
export const MENTOR_POST_REVIEW = `${HOST}/mentor/consultation/review/`;

// Tags
export const TAG_LIST = `${HOST}/tag/list/`;

// social

export const USER_INS_LOGIN = `${HOST}/user/instagram-social-login/`;
export const FETCH_INS_POST = `${HOST}/user/fetch-instagram-social-post/`;
export const FETCH_THIRDPARTY_POST = `${HOST}/user/third-party-post/list/`;
export const CHECK_THIRDPARTY_LOGIN = `${HOST}/user/fetch-post-login-check/`;
export const FETCH_THIRDPARTY_PUBLIC_POST = `${HOST}/user/third-party-public-post-list/`;
export const DELETE_THIRDPARTY_POST = `${HOST}/user/third-party-post/delete/`;
export const POST_THIRDPARTY_POST = `${HOST}/user/third-party-post/link/`;
export const UNPOST_THIRDPARTY_POST = `${HOST}/user/third-party-post/unlink/`;

// Events
const EVENT = `${HOST}/event`;
export const EVENT_LIST = `${EVENT}/list/`;
export const EVENT_DETAIL = `${EVENT}/detail/`;
export const FETCH_EVENT_DETAIL = `${EVENT}/event_detail_by_slug/`;
export const FETCH_EVENT_TEAMS = `${HOST}/team/list-for-event-detail/`;
export const FETCH_SINGLE_EVENT_TEAM = `${HOST}/team/detailById/`;
export const FETCH_EVENT_SUBMISSIONS = `${HOST}/hpanel/event/submission/list-by-event-slug/`;
export const FETCH_EVENT_SUBMISSIONS_FOR_JUDGE = `${HOST}/hpanel/event/submission/listForJudge/`;
export const FETCH_EVENT_SUBMISSION = `${HOST}/hpanel/event/submission/detail-by-id/`;
export const FETCH_EVENT_SUBMISSION_FOR_JUDGE = `${HOST}/hpanel/event/submission/judgeTeamSubmission/`;
export const FETCH_MY_TEAM_SUBMISSION = `${HOST}/hpanel/event/submission/myTeamSubmission/`;
export const FETCH_OTHER_TEAM_SUBMISSION = `${HOST}/hpanel/event/submission/otherTeamSubmission/`;
export const EVENT_APPLY = `${EVENT}/apply/`;
export const EVENT_LEAVE = `${EVENT}/leave/`;
export const EVENT_JOIN = `${EVENT}/join/`;
export const EVENT_FEATURES_LIST = `${EVENT}/features/list/`;
export const EVENT_FEATURES_UPDATE = `${EVENT}/features/update/`;
export const EVENT_RECOMMENDATION = `${HOST}/hpanel/event/getRecommendation/`;

export const EVENT_POSTING_LIST = `${HOST}/hpanel/event/HHTPostingLinked/`;

export const FETCH_SIGNED_VIDEO_UPLOAD_URL = `${HOST}/hpanel/event/prerecorded/videoUpload/`;
export const CN_FETCH_SIGNED_VIDEO_UPLOAD_URL = `${HOST}/hpanel/event/prerecorded/videoUpload/cn/`;
export const FETCH_PLAYABLE_VIDEO_URL = `${HOST}/hpanel/event/prerecorded/videoPlayLink/`;

export const FETCH_UPLOADED_CHANNEL_VIDEO_FILEKEYS = `${HOST}/hpanel/event/streaming/uploadedChannelVideoFileKeys/`;

export const FETCH_VIDEO_PREVIEW_LINK = `${HOST}/hpanel/event/streaming/getVideoPreviewLink/`;

export const GET_STORAGE_INFO = `${HOST}/hpanel/event/getStorageInfo/`;

export const ADMIN_REMOVE_FILE_OBJ = `${HOST}/hpanel/event/adminRemoveFileObject/`;

// Event comments
const EVENT_COMMENT = `${EVENT}/comment`;
export const EVENT_COMMENT_LIST = `${EVENT_COMMENT}/list/`;
export const EVENT_COMMENT_CREATE = `${EVENT_COMMENT}/create/`;
export const EVENT_COMMENT_UPDATE = `${EVENT_COMMENT}/update/`;
export const EVENT_COMMENT_REMOVE = `${EVENT_COMMENT}/remove/`;

const EVENT_COMMENT_REPLY = `${EVENT_COMMENT}/reply`;
export const EVENT_COMMENT_REPLY_CREATE = `${EVENT_COMMENT_REPLY}/create/`;
export const EVENT_COMMENT_REPLY_UPDATE = `${EVENT_COMMENT_REPLY}/update/`;

// Teams
const TEAM = `${HOST}/team`;
export const TEAM_LIST = `${TEAM}/list/`;
export const TEAM_CREATE = `${TEAM}/create/`;
export const TEAM_UPDATE = `${TEAM}/update/`;
export const TEAM_DELETE = `${TEAM}/delete/`;
export const TEAM_DETAIL = `${TEAM}/detail/`;
export const TEAM_APPLY = `${TEAM}/apply/`;
export const TEAM_ACCEPT = `${TEAM}/accept/`;
export const TEAM_REJECT = `${TEAM}/reject/`;
export const TEAM_LEAVE = `${TEAM}/leave/`;
export const TEAM_INVITE = `${TEAM}/invite/`;
export const TEAM_KICK = `${TEAM}/kick/`;
export const TEAM_FETCH_CREATEREPLY = `${TEAM}/ideaPost/create/`;
export const TEAM_FETCH_CHAT = `${TEAM}/ideaPost/list/`;

// Event Submissions
const ESUB = `${EVENT}/submission`;
export const EVENT_SUBMIT = `${ESUB}/`;
export const EVENT_SUBMSSION_LIST = `${ESUB}/list/`;
export const EVENT_SUBMSSION_DETAIL = `${ESUB}/detail/`;
export const EVENT_SUBMSSION_THUMBS_UP = `${ESUB}/thumbsUp/`;

// Mentor Help
// export const MENTOR_HELP_REQUEST = `${HOST}/eduhacks/mentor/slack/help/`;
// export const MENTOR_MARKING = `${HOST}/eduhacks/mentor/score/`;
export const MENTOR_MARKING = `${HOST}/event/submission/mark/`;

const MENTOR_BOT_SERVER = CONFIG.DEV
  ? 'https://hhmb-dev.hackhub.com'
  : `https://hhmb.hackhub.${isCNServer ? 'cn' : 'com'}`;

export const MENTOR_HELP_REQUEST = MENTOR_BOT_SERVER;
export const GET_SLACKHOOK = `${MENTOR_BOT_SERVER}/slack/get_hook`;
export const HANDLE_SLACK = `${MENTOR_BOT_SERVER}/slack/handle_slack`;

// CMS Event
const CMS_EVENT = `${HOST}/hpanel/event`;
export const FETCH_INITIAL_EVENTS = `${CMS_EVENT}/homepage/`;
export const FETCH_EVENT_LISTS = `${CMS_EVENT}/listPagination/`;
export const CMS_EVENT_DASHBOARD = `${CMS_EVENT}/dashboardFetch/`;
export const CMS_EVENT_DASHBOARD_MORE = `${CMS_EVENT}/dashboardCustomTimeRange/`;
const CMS_EVENT_SUBMISSION = `${CMS_EVENT}/submission`;
const CMS_EVENT_SCREENING = `${CMS_EVENT}/screening`;
export const CMS_EVENT_SCREENING_EMAIL_DETAIL = `${CMS_EVENT}/screening/email/detail/`;
export const CMS_EVENT_SCREENING_EMAIL_UPDATE = `${CMS_EVENT}/screening/email/update/`;
export const CMS_EVENT_FETCH = `${CMS_EVENT}/hosted/`;
export const CMS_EVENT_DETAIL = `${CMS_EVENT}/detail/`;
export const CMS_EVENT_CREATE = `${CMS_EVENT}/create/`;
export const CMS_EVENT_CLONE = `${CMS_EVENT}/cloneEvent/`;
export const CMS_EVENT_UPDATE = `${CMS_EVENT}/update/`;
export const CMS_EVENT_REMOVE = `${CMS_EVENT}/remove/all/`;
const CMS_EVENT_RANKING_BASE = `${CMS_EVENT}/ranking`;
export const CMS_EVENT_RANKING_ALL = `${CMS_EVENT_RANKING_BASE}/`;
export const CMS_EVENT_RANKING = `${CMS_EVENT_RANKING_BASE}/v2/`;
export const CMS_EVENT_RANKING_LIST_BY_MULTI_ROUND = `${CMS_EVENT_RANKING_BASE}/listByMultiRound/`;
export const CMS_EVENT_RANKING_DETAIL = `${CMS_EVENT}/ranking/detail/`;
export const CMS_EVENT_SUBMISSION_VISIBILITY = `${CMS_EVENT}/submission/visibility/`;
export const CMS_EVENT_SUBMISSION_VISIBILITY_TOGGLE = `${CMS_EVENT}/submission/visibility/toggle/`;
export const CMS_EVENT_COMMENTS_VISIBILITY = `${CMS_EVENT}/judge/toggleJudgeSubmissionCommentPublic/`;
export const CMS_EVENT_IMPORT_PARTICIPANT_CSV = `${CMS_EVENT}/csv/import/`;
export const CMS_EVENT_BATCH_REQUEST = `${CMS_EVENT}/csv/import/batch/request/`;
export const CMS_EVENT_INVOICES_FETCH = `${CMS_EVENT}/ticket/charges/list/`;
export const CMS_EVENT_COUPONS_FETCH = `${CMS_EVENT}/coupon/listByEventSlug/`;
export const CMS_EVENT_STRIPE_COUPONS_FETCH = `${CMS_EVENT}/stripeCoupon/listByEventSlug/`;
export const CMS_EVENT_STRIPE_COUPONS_CREATE = `${CMS_EVENT}/stripeCoupon/create/`;
export const CMS_EVENT_STRIPE_COUPONS_DETAIL = `${CMS_EVENT}/stripeCoupon/detail/`;
export const CMS_EVENT_STRIPE_COUPONS_DELETE = `${CMS_EVENT}/stripeCoupon/delete/`;
export const CMS_EVENT_GET_TAX_RATE = `${CMS_EVENT}/getTaxRate/`;
export const CMS_EVENT_CREATE_TAX_RATE = `${CMS_EVENT}/createUpdateTax/`;
export const CMS_EVENT_TOGGLE_TAX_ENABLED = `${CMS_EVENT}/toggleEventTaxEnabled/`;
export const CMS_EVENT_GET_PARTICIPANTS_REFUNDABLE = `${HOST}/stripe/refund/getParticipantRefundPolicy/`;
export const CMS_EVENT_UPDATE_PARTICIPANTS_REFUNDABLE = `${HOST}/stripe/refund/updateParticipantRefundPolicy/`;
export const CMS_EVENT_TOGGLE_PARTICIPANTS_REFUNDABLE = `${HOST}/stripe/refund/participantEnableToggle/`;

export const CMS_EVENT_COUPONS_CREATE = `${CMS_EVENT}/coupon/create/`;
export const CMS_EVENT_COUPONS_UPDATE = `${CMS_EVENT}/coupon/update/`;
export const CMS_EVENT_SCREENING_ACCEPT = `${CMS_EVENT_SCREENING}/accept/`;
export const CMS_EVENT_SCREENING_REJECT = `${CMS_EVENT_SCREENING}/reject/`;
export const CMS_EVENT_SCREENING_ACTION = `${CMS_EVENT}/application/screeningAction/`;
export const CMS_EVENT_SCREENING_ALL_PARTICIPANTS = `${CMS_EVENT}/application/collect/`;
export const CMS_EVENT_SCREENING_USERS = `${CMS_EVENT}/pending/list/`;
export const CMS_TEAM_MEMBERS_CSV = `${CMS_EVENT}/csv/team/members`;
export const CMS_TEAM_GROUP = `${CMS_EVENT}/team/group/`;
export const CMS_TEAM_LIST_BY_MULTI_ROUND = `${CMS_EVENT}/team/listByMultiRound/`;
export const CMS_MULTI_ROUND_PROMOTE_TEAMS = `${CMS_EVENT}/team/multiRoundPromoteTeams/`;
export const CMS_TEAM_GROUP_LIST = `${HOST}/team/group/list/`;
export const CMS_TEAM_GROUP_LIST_BY_MULTI_ROUND = `${HOST}/team/group/listByMultiRound/`;
export const CMS_TEAM_GROUP_ASSIGNGROUPTOJUDGE = `${HOST}/team/group/assignGroupToJudge/`;
export const CMS_TEAM_GROUP_ASSIGNGROUPTOTEAM = `${HOST}/team/group/assignGroupToTeam/`;
export const CMS_GENERATE_API = `${CMS_EVENT}/generateAPI/`;
export const CMS_ADMIN_TODO_STATUS = `${CMS_EVENT}/checklistStatus/`;
export const CMS_CHECK_MULTI_ROUND_REMOVE = `${CMS_EVENT}/multiRound/removeValidate/`;
export const CMS_EVENT_VALID_PARTICIPANTS_TICKETS = `${CMS_EVENT}/validTicket/`;
export const CMS_REFRESH_RECORDED_VIDEO_LINK = `${CMS_EVENT}/prerecorded/refreshOSSSTSToken/`;

export const NOTIFY_ORGANIZER = `${CMS_EVENT}/notifyOrganizer/email/`;

export const EVENT_SCHEDULE_DEMO = `${CMS_EVENT}/scheduleDemo/`;

// Application Form
export const CMS_EVENT_APPLICATION_GET = `${CMS_EVENT}/application/get/`;
export const CMS_EVENT_APPLICATION_CREATE = `${CMS_EVENT}/application/create/`;
export const CMS_EVENT_APPLICATION_FIELDS = `${CMS_EVENT}/application/fields/`;
export const CMS_EVENT_APPLICATION_COLLECT = `${CMS_EVENT}/application/collect/`;
export const CMS_EVENT_APPLICATION_ADD = `${CMS_EVENT}/application/add/`;
export const CMS_EVENT_APPLICATION_GETPROFILE = `${CMS_EVENT}/application/getprofile/`;

// Ranking Awards
export const CMS_EVENT_RANKING_AWARDS_FETCH = `${CMS_EVENT_RANKING_BASE}/awards/`;

// CMS Live Streaming
export const CMS_GET_PUBLISH_URL = CONFIG.DEV
  ? 'http://192.168.1.126:3001/course/stream'
  : 'https://cs.hackhub.cn/course/stream';

// CMS Announcement
const CMS_ANNOUNCEMENT = `${CMS_EVENT}/announcement`;
export const CMS_EVENT_ANNOUNCEMENT_PUBLISH = `${CMS_ANNOUNCEMENT}/publish/`;
export const CMS_EVENT_ANNOUNCEMENT_LIST = `${CMS_ANNOUNCEMENT}/list/`;
export const CMS_EVENT_ANNOUNCEMENT_UPDATE = `${CMS_ANNOUNCEMENT}/action/update/`;
export const CMS_EVENT_ANNOUNCEMENT_DELETE = `${CMS_ANNOUNCEMENT}/action/delete/`;

// CMS Judge
const CMS_JUDGE = `${CMS_EVENT}/judge`;
export const CMS_EVENT_JUDGE_LIST = `${CMS_JUDGE}/list/`;
export const CMS_MULTI_ROUND_JUDGE_LIST = `${CMS_EVENT}/judges/listByMultiRound/`;
export const CMS_EVENT_JUDGE_ADD = `${CMS_JUDGE}/add/`;
export const CMS_EVENT_JUDGE_REMOVE = `${CMS_JUDGE}/remove/`;

// CMS Mentor
const CMS_MENTOR = `${CMS_EVENT}/mentor`;
export const CMS_EVENT_MENTOR_LIST = `${CMS_MENTOR}/list/`;
export const CMS_EVENT_MENTOR_ADD = `${CMS_MENTOR}/add/`;
export const CMS_EVENT_MENTOR_REMOVE = `${CMS_MENTOR}/remove/`;
export const CMS_EVENT_MENTOR_TOGGLE = `${CMS_MENTOR}/toggle/`;

// CMS Volunteer
const CMS_VOLUNTEER = `${CMS_EVENT}/volunteer`;
export const CMS_EVENT_VOLUNTEER_LIST = `${CMS_VOLUNTEER}/list/`;
export const CMS_EVENT_VOLUNTEER_ADD = `${CMS_VOLUNTEER}/add/`;
export const CMS_EVENT_VOLUNTEER_REMOVE = `${CMS_VOLUNTEER}/remove/`;

// CMS Participant
const CMS_PARTICIPANT = `${CMS_EVENT}/participant`;
export const CMS_EVENT_PARTICIPANT_LIST = `${CMS_PARTICIPANT}/list/`;
export const CMS_EVENT_PARTICIPANT_ADD = `${CMS_PARTICIPANT}/add/`;
export const CMS_EVENT_PARTICIPANT_REMOVE = `${CMS_PARTICIPANT}/remove/`;

// CMS Judging Criteria
const CMS_JUDGING_CRITERIA = `${CMS_EVENT}/judging-criteria`;
export const CMS_EVENT_JUDGING_CRITERIA_LIST = `${CMS_JUDGING_CRITERIA}/list/`;
export const CMS_EVENT_JUDGING_CRITERIA_CREATE = `${CMS_JUDGING_CRITERIA}/create/`;
export const CMS_EVENT_JUDGING_CRITERIA_REMOVE = `${CMS_JUDGING_CRITERIA}/remove/`;
export const CMS_EVENT_JUDGING_CRITERIA_UPDATE = `${CMS_JUDGING_CRITERIA}/update/`;
export const CMS_EVENT_JUDGING_CRITERIA_REORDER = `${CMS_EVENT}/change/jc/ordering/`;
export const CMS_EVENT_JUDGING_CRITERIA_LIST_BY_MULTI_ROUND = `${CMS_JUDGING_CRITERIA}/listByMultiRound/`;

// CMS Awards
const CMS_AWARD = `${CMS_EVENT}/award`;
export const CMS_EVENT_AWARD_LIST = `${CMS_AWARD}/list/`;
export const CMS_EVENT_AWARD_CREATE = `${CMS_AWARD}/create/`;
export const CMS_EVENT_AWARD_REMOVE = `${CMS_AWARD}/remove/`;
export const CMS_EVENT_AWARD_UPDATE = `${CMS_AWARD}/update/`;
export const CMS_EVENT_AWARD_GIVE = `${CMS_AWARD}/give/`;
export const CMS_EVENT_AWARD_CANCEL = `${CMS_AWARD}/cancel/`;
export const CMS_EVENT_AWARD_REORDER = `${CMS_EVENT}/change/award/ordering/`;

// CMS Topics
const CMS_TOPIC = `${CMS_EVENT}/topic`;
export const CMS_EVENT_TOPIC_LIST = `${CMS_TOPIC}/list/`;
export const CMS_EVENT_TOPIC_CREATE = `${CMS_TOPIC}/create/`;
export const CMS_EVENT_TOPIC_REMOVE = `${CMS_TOPIC}/remove/`;
export const CMS_EVENT_TOPIC_UPDATE = `${CMS_TOPIC}/update/`;
export const CMS_EVENT_TOPIC_REORDER = `${CMS_EVENT}/change/topic/ordering/`;

// CMS Resources
const CMS_EVENT_RESOURCES = `${CMS_EVENT}/resource`;
export const CMS_EVENT_RESOURCES_LIST = `${CMS_EVENT_RESOURCES}/list/`;
export const CMS_EVENT_RESOURCES_CREATE = `${CMS_EVENT_RESOURCES}/create/`;
export const CMS_EVENT_RESOURCES_UPDATE = `${CMS_EVENT_RESOURCES}/update/`;
export const CMS_EVENT_RESOURCES_REMOVE = `${CMS_EVENT_RESOURCES}/remove/`;

// CMS LIVESTREAMING
const CMS_EVENT_STREAMING = `${CMS_EVENT}/streaming`;
export const CMS_EVENT_STREAMING_LIST = `${CMS_EVENT_STREAMING}/list/`;
export const CMS_EVENT_STREAMING_CREATE = `${CMS_EVENT_STREAMING}/create/`;
export const CMS_EVENT_STREAMING_UPDATE = `${CMS_EVENT_STREAMING}/update/`;
export const CMS_EVENT_STREAMING_DELETE = `${CMS_EVENT_STREAMING}/delete/`;
export const EVENT_STREAMING_ZOOM_SIGNATURE = `${CMS_EVENT_STREAMING}/zoom/signature/`;
export const EVENT_STREAMING_ZOOM_CREATE_MEETING = `${CMS_EVENT_STREAMING}/zoom/createMeeting/`;

// CMS Tickets
const CMS_TICKET = `${CMS_EVENT}/ticket`;
export const CMS_EVENT_TICKET_LIST = `${CMS_TICKET}/list/`;
export const CMS_EVENT_TICKET_CREATE = `${CMS_TICKET}/create/`;
export const CMS_EVENT_TICKET_REMOVE = `${CMS_TICKET}/remove/`;
export const CMS_EVENT_TICKET_UPDATE = `${CMS_TICKET}/update/`;
export const CMS_EVENT_TICKET_REORDER = `${CMS_TICKET}/ordering/`;

// CMS Settings
const CMS_MANAGER = `${CMS_EVENT}/manager`;
export const CMS_EVENT_MANAGER_LIST = `${CMS_MANAGER}/list/`;
export const CMS_EVENT_MANAGER_UPDATE = `${CMS_MANAGER}/update/`;

// Stripe
const STRIPE = `${HOST}/stripe`;
export const STRIPE_REFUND = `${STRIPE}/refund/e-ticket/`;
export const STRIPE_CREATE_CHECKOUT_SESSION = `${STRIPE}/checkout/e-ticket/`;
export const STRIPE_CANCEL_CHECKOUT_SESSION = `${STRIPE}/checkout/cancel/`;
export const STRIPE_CREATE_ACCOUNT_SESSION = `${STRIPE}/organizer/getOnboardLink/`;
export const STRIPE_ACCOUNT_LOGIN_SESSION = `${STRIPE}/organizer/getStripeDashboardLoginLink/`;
export const STRIPE_IF_FINISHED_ONBOARDING_PROCESS = `${STRIPE}/organizer/hasFinishedOnboarding/`;

const STRIPE_CARD = `${STRIPE}/card`;

export const STRIPE_CARD_LIST = `${STRIPE_CARD}/list/`;
export const STRIPE_CARD_CREATE = `${STRIPE_CARD}/create/`;
export const STRIPE_CARD_REMOVE = `${STRIPE_CARD}/remove/`;
export const STRIPE_CARD_CHARGE = `${STRIPE}/charge/card/e-ticket/`;
export const STRIPE_CARD_DEFAULT = `${STRIPE_CARD}/default/`;
export const APPLY_COUPON_CODE = `${STRIPE}/coupon/validCode/`;

// Registration form
// DEPRECATED
export const REG_SCHEMA = CONFIG.DEV
  ? 'https://hackhub-form-server.herokuapp.com/schema'
  : 'https://hackhub.com/form/schema';

// Graphql Endpoint
export const GRAPH_URL = CONFIG.DEV
  ? `${HOST}/graphql/`
  : `${HOST}/hh-graphql/`;

export const NOTIFICATION_SERVER_URL = CONFIG.DEV
  ? 'https://hhns-dev.hackhub.com'
  : `https://hhns.hackhub.${isCNServer ? 'cn' : 'com'}`;

export const NOTIFICATION_URL = `${NOTIFICATION_SERVER_URL}/notifications`;
export const NOTIFICATION_RETRIEVE = `${NOTIFICATION_URL}/all`;
export const NOTIFICATION_CREATE = `${NOTIFICATION_URL}/create`;
export const NOTIFICATION_UPDATE = `${NOTIFICATION_URL}/update`;
export const NOTIFICATION_DELETE = `${NOTIFICATION_URL}/delete`;
export const NOTIFICATION_DELETE_ALL = `${NOTIFICATION_URL}/delete/all`;

// export const ANNOUNCEMENT_URL = `${NOTIFICATION_SERVER_URL}/announcements`;
// export const ANNOUNCEMENT_RETRIEVE = `${ANNOUNCEMENT_URL}/all`;
// export const ANNOUNCEMENT_CREATE = `${ANNOUNCEMENT_URL}/create`;
// export const ANNOUNCEMENT_UPDATE = `${ANNOUNCEMENT_URL}/update`;
// export const ANNOUNCEMENT_DELETE = `${ANNOUNCEMENT_URL}/delete`;

const FILE_SERVICE = CONFIG.DEV
  ? 'https://hhfs-dev.hackhub.com'
  : `https://hhfs.hackhub.${isCNServer ? 'cn' : 'com'}`;

export const IMAGE_RESIZE = (size, file) =>
  `${FILE_SERVICE}/transform?size=${size}&file=${file}`;

export const UPLOAD_FILE = `${FILE_SERVICE}${
  isCNServer ? '/advancedUpload/cn-event-upload/stream' : '/upload'
}`;

export const FETCH_UPLOAD_SIGNED_URL = `${FILE_SERVICE}/upload/fetchUploadSignedUrl/`;

export const GET_TEMP_BUCKET_PREVIEW_URL = `${FILE_SERVICE}/upload/getTmpBucketPreviewAccess/`;

export const POST_UPLOAD_ACTION = `${FILE_SERVICE}/upload/postUploadAction`;

export const FETCH_LARGE_UPLOAD_SIGNED_URL = `${FILE_SERVICE}/upload/fetchLargeFUploadSignedURL/`;

export const GET_LARGE_FILE_PREVIEW_URL = `${FILE_SERVICE}/upload/largeObjectKeyToAccessLink/`;


// TO DO: ADD PRODUCTION PUBLIC BUCKET URL
export const PUBLIC_BUCKET_CDN = CONFIG.DEV ? 'https://d9zmlp9u1xlkh.cloudfront.net/' : isCNServer ? 'http://cdn-public.hackhub.cn/' : 'http://dklxoto1ofmtn.cloudfront.net/';


export const UPLOAD_VIDEO = `${FILE_SERVICE}/advancedUpload/HHEventStreamingVideoUpload`;

export const RESUME_ANALYZE = CONFIG.DEV
  ? 'https://hhra-dev.hackhub.com'
  : `https://hhra.hackhub.${isCNServer ? 'cn' : 'com'}`;

export const RESUME_SCORE = CONFIG.DEV
  ? 'https://hhra-dev.hackhub.com/score'
  : `https://hhra.hackhub.${isCNServer ? 'cn' : 'com'}/score`;

export const GITHUB_REPO_COMMITS = (owner, repo) =>
  `https://api.github.com/repos/${owner}/${repo}/commits`;

const HH_SERVICES = CONFIG.DEV
  // ? 'http://localhost:3006'
  ? 'https://hhservices-dev.hackhub.com'
  : `https://hhse.hackhub.${isCNServer ? 'cn' : 'com'}`;

export const GET_STREAM_URL = `${HH_SERVICES}/event-streaming/event/generate-push-url`;

export const ADMISSION_STATUS = `${HH_SERVICES}/admission/status`;
export const ADMISSION_STATUS_GET = `${ADMISSION_STATUS}/get`;
export const ADMISSION_STATUS_DELETE = `${ADMISSION_STATUS}/update`;
export const ADMISSION_STATUS_LIST = `${ADMISSION_STATUS}/list`;

// using micro service to invite
export const CMS_EVENT_PARTICIPANT_INVITE = `${HH_SERVICES}/event/invitation/create`;
export const CMS_EVENT_SEND_PARTICIPANT_INVITATION_EMAIL = `${CMS_EVENT}/invite/email/`;
export const CMS_EVENT_VERIFY_INVITE_TOKEN = `${HH_SERVICES}/event/invitation/verify`;
export const CMS_EVENT_GET_LOCATIONS = `${HH_SERVICES}/location`;
const HH_SERVICES_XINGSHIBEI = `${HH_SERVICES}/xingshibei`;
const HH_SERVICES_USER = `${HH_SERVICES}/user`;
export const CMS_EVENT_GET_CANDIDATE_LIST = `${HH_SERVICES_XINGSHIBEI}/profile/list`;
export const HHSERVICES_USER_PROFILE_RETRIEVE = `${HH_SERVICES_USER}/profile/retrieve`;
export const HHSERVICES_USER_APPEND_PROJECT = `${HH_SERVICES_USER}/profile/append/project`;
export const HHSERVICES_USER_UPDATE_PROJECT = `${HH_SERVICES_USER}/profile/update/project`;
export const HHSERVICES_USER_REMOVE_PROJECT = `${HH_SERVICES_USER}/profile/remove/project`;
export const HHSERVICES_XINSHIBEI_APPEND_PROJECT = `${HH_SERVICES_XINGSHIBEI}/profile/append/project`;
export const HHSERVICES_XINSHIBEI_REMOVE_PROJECT = `${HH_SERVICES_XINGSHIBEI}/profile/remove/project`;
export const HHSERVICES_XINSHIBEI_CREATE_PROFILE = `${HH_SERVICES_XINGSHIBEI}/profile/create`;
export const HHSERVICES_XINSHIBEI_RETRIEVE_PROFILE = `${HH_SERVICES_XINGSHIBEI}/profile/retrieve`;
export const HHSERVICES_PHONE_GET_VERIFYCODE = `${HH_SERVICES}/phone/sms/code`;
export const HHSERVICES_PHONE_VERIFY = `${HH_SERVICES}/phone/sms/verify`;
export const DJANGO_XINSHIBEI_REGISTER = `${USER}/xingshibei/register/`;

// qrcode
export const QRCODE_LOGIN_SCAN = `${HH_SERVICES}/qrcode/web/login/scan`;
export const QRCODE_LOGIN_CONFIRM = `${HH_SERVICES}/qrcode/web/login/confirm`;

// chatRoom
const CHAT_ROOM_HOST = CONFIG.DEV
  // ? 'http://localhost:3008'
  ? 'https://hhchat-dev.hackhub.com'
  : 'https://hhct.hackhub.com';
// export const CHAT_ROOM_HOST = 'https://hhchat-dev.hackhub.com';

export const CREATE_NEW_CHATROOM = `${CHAT_ROOM_HOST}/chat/create-update`;
export const FULL_MSG_HISTORY = `${CHAT_ROOM_HOST}/chat/full-msg-history`;
export const USER_CHAT_DETAIL = `${CHAT_ROOM_HOST}/chat/detail-by-user`;
export const USER_CHAT_LOGIN = `${CHAT_ROOM_HOST}/profile/chatLogin`;
export const GET_FULL_HISTORY = `${CHAT_ROOM_HOST}/chat/full-msg-history`;

// page-builder
export const PAGE_BUILDER = CONFIG.DEV
  ? 'https://hh-pagebuilder.hackhub.com'
  : 'https://hh-pagebuilder.hackhub.com';

export const PAGE_BUILDER_LOAD = `${PAGE_BUILDER}/load`;
export const PAGE_BUILDER_TEMPLATE_UPDATE = `${PAGE_BUILDER}/update`;
export const PAGE_BUILDER_CREATE = `${HOST}/hpanel/event/page-builder/create/`;
export const PAGE_BUILDER_UPDATE = `${HOST}/hpanel/event/page-builder/update/`;
export const PAGE_BUILDER_DELETE = `${HOST}/hpanel/event/page-builder/delete/`;
export const PAGE_BUILDER_LIST = `${HOST}/hpanel/event/page-builder/list/`;
export const GET_MEMBER_STATUS = `${CHAT_ROOM_HOST}/chat/get-user-status-by-slug`;
export const GET_LC_HISTORY = `${CHAT_ROOM_HOST}/large-chat/get-recent-by-time`;
export const GET_EVENT_MEMBER_PROFILE = `${CMS_EVENT}/eventMemberProfileInfo/`;



// WEBPACK FOOTER //
// ./src/components/network/api.js